import React from "react";
import { Heading, Link, Text, Tooltip } from "@foris/avocado-suite";
import styles from "./classroomsResumeTooltip.module.scss";
import { Icon } from "@foris/avocado-icons";
import { useTranslation } from "react-i18next";

type ClassroomDate = {
  date: string;
  classroom: string;
};

interface ClassroomsResumeTooltipProps {
  classroomsDates: ClassroomDate[];
}

const ClassroomsResumeTooltip = ({ classroomsDates = [] }: ClassroomsResumeTooltipProps) => {
  const { t } = useTranslation();

  if (!classroomsDates?.length) return null;

  return (
    <Tooltip
      className={styles.classroomsResumeTooltip}
      label={
        <div className={styles.classroomsResumeTooltip_content}>
          <Heading type="h3">{t("booking.booking-request.resume.classrooms-resume")}</Heading>

          <ul className={styles.classroomsResumeTooltip_classroomsDates}>
            {classroomsDates?.map((classroomDate, index) => (
              <li className={styles.classroomsResumeTooltip_classroomRow} key={index}>
                <Text className={styles.classroomsResumeTooltip_classroomDate}>
                  {classroomDate?.date}
                </Text>
                <Icon name="chevron-right" size="sm" color="neutral-50" />
                <Text>{classroomDate?.classroom}</Text>
              </li>
            ))}
          </ul>
        </div>
      }
      placement="right"
    >
      <Link className={styles.classroomsResumeTooltip_link} iconRight="chevron-right">
        {t("booking.booking-request.resume.classrooms-resume")}
      </Link>
    </Tooltip>
  );
};

export default ClassroomsResumeTooltip;
